import React from 'react';
import logoCKE from '../../assets/logos/CKE.png';
import logoCKEHC from '../../assets/logos/CKE_HC.png';
import logoRP from '../../assets/logos/RP.png';
import logoRPHC from '../../assets/logos/RP_HC.png';
import logoFE from '../../assets/logos/FE.png';
import logoFEHC from '../../assets/logos/FE_HC.png';
import logoUE from '../../assets/logos/UE.png';
import logoUEHC from '../../assets/logos/UE_HC.png';
import logoMEN from '../../assets/logos/MEN.png';
import logoMENHC from '../../assets/logos/MEN_HC.png';
import { useStyles } from './SelectEnvironment.styles';
import { ConfirmSelection } from './ConfirmSelection.component';
import useDocumentTitle from '../../hooks/DocumentTitle/documentTitle';
import { useHighContrastMode } from '../../utils/highContrastChecker';
import { useTranslation } from 'react-i18next';

export const SelectEnvironment: React.FC = () => {
  const styles = useStyles();
  useDocumentTitle('Wybierz środowisko');
  const highContrastMode = useHighContrastMode();
  const { t } = useTranslation();

  return (
    <div className={styles.container}>
      <div className={styles.cardHeader}>
        <ConfirmSelection />
        <div className={styles.footer}>
          <hr className={styles.separator} />
          <div className={styles.logosContainer}>
            <img
              src={!highContrastMode ? logoFE : logoFEHC}
              alt={'Logo Fundusze Europejskie'}
              className={styles.logo}
            />
            <img
              src={!highContrastMode ? logoRP : logoRPHC}
              alt={'Logo Rzeczpospolita Polska'}
              className={styles.logo}
            />
            <img
              src={!highContrastMode ? logoMEN : logoMENHC}
              alt={'Logo Ministerstwo Edukacji i Nauki'}
              className={styles.logo}
            />
            <img src={!highContrastMode ? logoCKE : logoCKEHC} alt={'Logo CKE'} className={styles.logo} />
            <img src={!highContrastMode ? logoUE : logoUEHC} alt={'Logo UE'} className={styles.logo} />
          </div>
        </div>
      </div>
      <div className={styles.sidePanel}>
        <h2 className={styles.sideHeader}>{`Witaj w aplikacji ${t('global:shortNames.system')}`}</h2>
        <svg viewBox="0 0 414 402" fill="none" xmlns="http://www.w3.org/2000/svg" transform="translate(0,235)">
          <path
            d="M785.65 141.614C764.15 137.114 734.25 130.814 704.25 118.414C674.05 106.014 644.15 88.9137 615.25 70.9137C608.05 66.4137 600.75 61.8138 593.65 57.2138C572.25 43.5138 550.85 29.5138 527.65 19.0138C524.95 17.8138 522.25 16.6138 519.55 15.5138C490.65 3.81375 459.05 -1.48625 428.75 2.11375C387.95 6.91375 352.45 26.4138 321.15 51.7138C285.05 80.9138 253.35 120.814 227.95 157.714C216.45 174.314 206.95 189.914 200.25 205.214C190.45 227.414 183.25 253.614 155.25 264.014C140.25 269.514 122.95 267.814 106.95 263.514C100.75 261.814 94.8499 259.814 89.4499 257.514C69.9499 249.214 54.2499 238.714 36.4499 232.614C20.9499 227.314 2.04992 225.714 -14.1501 234.014C-16.6501 235.314 -19.0501 236.814 -21.3501 238.514C-42.1501 254.114 -48.2501 284.714 -49.9501 311.214C-51.1501 330.414 -51.3501 350.114 -56.9501 368.114C-59.1501 375.114 -62.1501 381.914 -66.3501 388.214C-82.4501 412.314 -114.35 424.014 -142.95 420.114C-171.65 416.214 -195.35 397.614 -213.25 375.814C-235.85 348.414 -249.95 311.214 -248.95 273.814"
            stroke="white"
            strokeOpacity="0.3"
            strokeWidth="0.9463"
            strokeMiterlimit="10"
          />
        </svg>
        <svg viewBox="0 0 414 327" fill="none" xmlns="http://www.w3.org/2000/svg" transform="translate(0,-200)">
          <path
            d="M-161 353.5C-100.3 356.2 -39.1 328.5 -0.800003 281.5C21.9 253.4 36.9 219 63.5 193.6C92.5 166 131 153 171.3 149.4C192.6 147.5 214.4 148.2 235.4 150.6C255.6 152.9 275.9 156.6 296 160.3C322 165.2 348 170.2 374.1 171.7C388.5 172.5 402.9 172.2 417.2 170.6C440.9 167.8 463.5 161.4 485.1 152.8C519.6 139 552.4 119.3 585.8 99.2999C618.8 79.5999 651.9 59.8999 685.7 43.0999C716 28.0999 747.1 15.3999 780 7.19992C784.4 6.09992 788.8 5.09992 793.3 4.19992C813.6 0.0999248 834.5 -1.40007 853.9 3.79992C877.6 10.0999 898.2 28.4999 900 50.5999"
            stroke="#C3C6FF"
            strokeWidth="0.9463"
            strokeMiterlimit="10"
          />
        </svg>
      </div>
    </div>
  );
};
